import { css, jsx } from '@emotion/react';
import { Link } from '@zapier/design-system';
import { useUniversalNavContext } from '../../../universal-nav/hooks';
import { baseReset, interactiveReset, boxSizing, listReset, } from '../../../utils/style-mixins/reset';
export const CssVars = {
    justifyContent: '--UniversalFooter__HelpfulLinks-justify-content',
};
const Styles = {
    root: css `
    ${boxSizing};
    font: var(--zds-body-2);
    // Cheating here so we can use border-left to keep the pipes between links at 20px high
    line-height: 20px;
    color: var(--zds-text-default, #413735);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: var(${CssVars.justifyContent}, center);
    row-gap: 10px;
  `,
    copyright: css `
    ${baseReset};
    margin-right: var(--zds-space-8, 8px);
  `,
    links: css `
    ${listReset};
    display: inherit;
    align-items: inherit;
    justify-content: inherit;
    white-space: nowrap;
  `,
    linkItem: css `
    ${boxSizing};
    border-left: 1px solid var(--zds-stroke-weaker, #d7d3c9);
    &:first-of-type {
      border-left: none;
    }
  `,
    link: (isButton = false) => css `
    ${interactiveReset};
    // Increase hit area and separate.
    padding: ${isButton ? '0' : '5px'} var(--zds-space-12, 12px);
    color: var(--zds-text-default, #413735) !important;
    text-decoration: none;
    &:hover,
    &:focus {
      color: var(--zds-ui-primary-strongest, #503ebd) !important;
      outline: none;
    }
  `,
};
export const ZapierMeta = ({ links = [
    {
        text: 'Manage cookies',
        className: 'ot-sdk-show-settings',
        style: { display: 'none' },
    },
    { text: 'Legal', href: '/legal' },
    { text: 'Privacy', href: '/privacy' },
], }) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const linkNodes = links.map((link) => {
        const content = link.href ? (jsx(Link, { css: Styles.link(false), color: null, href: getFullyQualifiedURL(link.href) }, link.text)) : (jsx("button", { className: link.className, css: Styles.link(true), style: link.style, type: "button", "data-zds": true }, link.text));
        return (jsx("li", { key: link.text, css: Styles.linkItem, "data-zds": true }, content));
    });
    return (jsx("div", { css: Styles.root, "data-zds": true },
        jsx("p", { css: Styles.copyright, "data-zds": true },
            "\u00A9 ",
            new Date().getFullYear(),
            " Zapier Inc."),
        jsx("ul", { css: Styles.links, "data-zds": true }, linkNodes)));
};
//# sourceMappingURL=ZapierMeta.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
